import React from 'react'
import FormPage from '../FormPage'
import Auth from "../../Auth";
import ReactDOM from "react-dom";
import { useParams, Link } from "react-router-dom";
import { Check } from 'lucide-react';
import { Collapse } from 'antd';

export default class AuthTalentSignup extends FormPage {
    static path = '/signup/talent/:token';

    /**
     * The title shown on the form
     */
    static FormViewTitle = "auth.signup.talent.title";

    /**
     * The title shown on the form
     */
    static FormViewSubtitle = "auth.signup.talent.subtitle";

    /**
     * The submit button title for the form
     */
    static FormSubmit = 'Continue'; // TB.trans("auth.signup.talent.submit_button");

    /**
     * The links mapping for the form
     */
    static FormViewLinks = [
        {
            title: 'auth.signup.talent.subtitle_login_link',
            path: '/login',
        }
    ];

    /**
     * The fields mapping for the form
     */
    static FormFields = {

        title: this.renderTitle(),

        first_name: {
            label: 'auth.signup.talent.first_name_label',
            placeholder: TB.trans('auth.signup.talent.first_name_placeholder'),
        },
        last_name: {
            label: 'auth.signup.talent.last_name_label',
            placeholder: TB.trans('auth.signup.talent.last_name_placeholder'),
        },
        email: {
            type: 'email',
            label: 'auth.signup.talent.email_label',
            placeholder: TB.trans('auth.signup.talent.email_placeholder'),
        },
        password: {
            type: 'new_password',
            label: 'auth.signup.talent.password_label',
            placeholder: TB.trans('auth.signup.talent.password_placeholder'),
        },
        password_confirmation: {
            type: 'password_confirmation',
            label: 'auth.signup.talent.confirm_password_label',
            placeholder: TB.trans('auth.signup.talent.confirm_password_placeholder'),
        },
        // remember_me: {
        //     type: 'checkbox',
        //     label: 'auth.signup.talent.remember_label',
        //     required: false
        // },
    };

    validateBeforeSubmit = true;

    /**
* [Constructor]
*
* @param {Object} props
* @returns {FormPage}
*/
    constructor(props) {
        super(props);

        let user = laravel.referred_user
            || {};

        this.state = {
            ...this.state,
            isDisabled: false,
            model: { ...user },
        };
    }

    static formViewTitle() {
        return TB.tryTrans(
            this.FormViewTitle
        );
    }

    static formViewSubtitle() {
        return TB.tryTrans(
            this.FormViewSubtitle
        );
    }

    static formViewLinks() {
        return this.FormViewLinks;
    }

    /**
     * Maps form input data to form submit model
     * Appends token to form data from url route parameter
     *
     * @param {Object} model
     * @returns {Object}
     */
    mapping(model) {
        model.referral_token = this.props.token;

        return model;
    }

    /**
* Handles form submit button clicks when form is valid
*
* @param {Object} creds
* @returns void
*/
    async onSubmit(creds) {
        let postData = { ...creds };

        if (this.hasQueryParam('ref')) {
            postData.referred_by = this.queryParam('ref');
        }
        if (this.hasQueryParam('ref_name')) {
            postData.referred_by_name = this.queryParam('ref_name');
        }

        // TB.log().object(
        // 	'Talent Signup @ onSubmit', { ...postData }
        // );

        let isDisabled = true;
        await this.promisedState({ isDisabled });

        let auth = TB.auth();
        let user = await auth.talentSignup(postData).catch(console.warn);
        if (!auth.NeedsTwoFactorConfirmed
            && !user
            && this.formRef.current) {
            await this.promisedState({ isDisabled: false })
            return this.onError(user)
        }

        return this.promisedState({ isDisabled })
    }

    async onError(e) {

        if (Auth.TalentSignupRequest.didFail
            && Auth.TalentSignupRequest.statusCode() === 422
            && this.formRef.current) {
            try {
                let invalid = await this.formRef.current.handleInputResponseError(Auth.TalentSignupRequest)
                if (invalid) {
                    const node = ReactDOM.findDOMNode(invalid);

                    $('html, body').animate({ scrollTop: $(node).offset().top }, 1000);
                    return false;
                }
            } catch (e) {
                console.warn('ERROR: handleInputResponseError', e);
            }
        }
    }

    // async onSuccess(response) {
    //
    //     try {
    //         Auth.User = {...response.data.auth};
    //         Auth.DidExpire = false;
    //
    //         await Auth.onUpdate();
    //
    //         TB.event('Auth@Update');
    //
    //         console.log('Auth', this.context?.auth)
    //     }catch (e) {
    //         console.log('ERROR: onSuccess', e);
    //     }
    // }

    /**
     * Render the form
     *
     * @returns {Form}
     */
    render() {
        return (
            <div className='container-fluid'>

                {this.renderFormView()}

            </div>
        );
    }

    /**
     * Overridable method for rendering any form child elements
     *
     * @returns {Component}
     */
    renderFormView() {

        const steps = [
            { title: 'Create account', description: "You're here" },
            { title: 'Complete application', description: 'About 12 min · reviewed in 24–72 hours' },
            { title: 'Build profile', description: 'About 11 min · reviewed in 1–2 business days' },
            { title: 'Live', description: 'Clients can find you — start proposing to projects' },
        ];

        const isWrippleRightForMe = [
            'Demonstrated capability in and passion for at least one marketing discipline: experience design, marketing createive, engagement leadership, strategy and planning, tech and AI, or media.',
            "Valuable professional experience at an agency, consultancy, or on a company's marketing team or in-house agency.",
            '(Early career) 3 - 5 years of focused experience and the ability to deliver as a valued team member, or',
            '(Advanced career) 6+ years of experience and the ability to lead initiatives and teams.'
        ]

        return (
            <div className="signup-banner">
                <div className="branding gap-8 !flex-1 pt-8 pb-12">
                    <div className="flex flex-col gap-8 max-w-[780px] ">

                        {laravel.platform_settings.Asset_Logo_Brand_Image?.length > 0 && (
                            <div>
                                <img src={laravel.platform_settings.Asset_Logo_Brand_Image} className="h-[36px]" alt="Wripple Logo" />
                            </div>
                        )}

                        <div className="px-7 py-2 rounded-md bg-secondary text-white inline-block self-start">
                            <span>For marketing freelancers</span>
                        </div>

                        <p className="text-5xl font-bold whitespace-normal leading-snug text-secondary">
                            Join Wripple and work with great brands.
                        </p>
                        <p className="text-base text-gray-700">
                            Most freelancers are <b className="text-gray-900">live within about a week.</b>
                        </p>

                        <div className="flex flex-col pl-4">
                            {steps.map((step, i) => {
                                const isFirst = i === 0;

                                const bg = isFirst ? 'bg-secondary' : 'bg-transparent';
                                const border = isFirst ? 'border-secondary' : 'border-gray-300';
                                const color = isFirst ? 'text-white' : 'text-gray-400';

                                return (
                                    <div
                                        key={i}
                                        className="flex items-start gap-3"
                                    >
                                        <div className="flex flex-col items-center">

                                            <div className={`flex items-center justify-center rounded-full font-semibold flex-shrink-0 h-[32px] w-[32px] border-2 ${bg} ${border} ${color} text-[13px]`}>
                                                {i + 1}
                                            </div>
                                            {(i !== steps.length - 1) && (
                                                <div
                                                    className="w-0.5 flex1 my-1"
                                                    style={{
                                                        minHeight: 44,
                                                        backgroundColor: '#D4D0E0',
                                                    }}
                                                />
                                            )}
                                        </div>
                                        <div className="pt1.5">
                                            <div className="flex flex-col">
                                                <span className={`text-base whitespace-nowrap font-medium text-gray-800`}>
                                                    {step.title}
                                                </span>
                                                {step.description && (
                                                    <span className={`text-sm ${isFirst ? 'text-secondary font-medium' : 'text-gray-500'}`}>
                                                        {step.description}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>

                        <Collapse
                            ghost
                            expandIcon={() => null}
                            className="wripple-right-for-me-collapse [&_.ant-collapse-header]:pb-0"
                        >
                            <Collapse.Panel
                                key="1"
                                header={
                                    <p className="text-secondary text-xl font-extrabold underline cursor-pointer m-0">
                                        Is Wripple right for me?
                                    </p>
                                }
                            >
                                <div className="flex flex-col gap-2 bg-white p-6 rounded-lg">
                                    <p className="text-base text-gray-600">We're excited to meet talent marketing pros who love doing great client work.</p>
                                    <p className="text-base font-bold">To be considered, we require ALL of the following:</p>

                                    {isWrippleRightForMe.map((item, idx) => {
                                        return (
                                            <div key={idx} className="flex gap-2.5 py-1">
                                                <Check className="h-4 w-4 shrink-0 mt-0.5" />
                                                <p className="text-sm text-gray-600">
                                                    {item}
                                                </p>
                                            </div>
                                        )
                                    })}
                                </div>
                            </Collapse.Panel>
                        </Collapse>

                    </div>
                </div>

                <div className="signup-form py-4 md:w-2/5 bg-white mb-6 md:mx-0 md:mb-0">
                    {this.renderForm()}
                    <p className="m-0 mt-4 px-4 text-center text-sm text-gray-500">
                        Next: your application — about 12 minutes, saved as you go.
                    </p>
                </div>

            </div>
        )
        return (
            <div className="signup-banner">
                <div className="branding">

                    {laravel.platform_settings.Asset_Logo_Brand_Image?.length > 0 && (
                        <div className="logo-heading" style={{ backgroundImage: `url("${laravel.platform_settings.Asset_Logo_Brand_Image}")` }} />
                    )}

                    <h3 className="py-2 px-4 my-8 mb-4 bg-secondary text-white">For Freelancers</h3>

                    <svg className="heading" viewBox="0 0 115 20">
                        <text fill={TB.config("color.light_purple")} x="0" y="15">
                            {TB.trans('talent.banner.logo_heading_1')}
                        </text>
                    </svg>
                    <svg className="heading" viewBox="0 0 115 20">
                        <text fill={TB.config("color.light_purple")} x="0" y="15">
                            {TB.trans('talent.banner.logo_heading_2')}
                        </text>
                    </svg>
                    <svg className="heading" viewBox="0 0 115 20">
                        <text fill={TB.config("color.light_purple")} x="0" y="15">
                            {TB.trans('talent.banner.logo_heading_3')}
                        </text>
                    </svg>
                    <svg className="heading" viewBox="0 0 115 20">
                        <text fill={TB.config("color.light_purple")} x="0" y="15">
                            {TB.trans('talent.banner.logo_heading_4')}
                        </text>
                    </svg>
                    <p className="subheading">
                        {TB.trans('talent.banner.sub_heading')}
                    </p>
                </div>

                <div className="signup-form py-4 bg-white mb-6 md:mx-0 md:mb-0">
                    {this.renderForm()}
                </div>

            </div>
        );
    }

    static renderTitle() {
        let links = this.formViewLinks();

        return (
            <div className="form-title-section">
                <h3 className="form-title">
                    {/* {this.formViewTitle()} */}
                    Start your application
                </h3>
                <h5 className="form-subtitle">
                    {this.formViewSubtitle()}

                    {links.map((link, i) => (
                        <Link key={`signup-link-${i}`}
                            to={link.path}
                            aria-label={TB.tryTrans(link.title)}
                            className="text-wripplePrimaryBrightPurple"
                        >
                            {TB.tryTrans(link.title)}
                        </Link>
                    ))}
                </h5>
            </div>
        )
    }
}


const TalentSignup = (props) => {
    const { token } = useParams();

    return (
        <AuthTalentSignup token={token} />
    )
}

export {
    TalentSignup
}